@if (!this.isUserConnected()) {
  <div class="loader-connection">
    <ml-loader />
  </div>
} @else {
  @if (oidcUser()) {
    @if (pvmoUser()) {
      @let _pvmoUser = pvmoUser();
      <div class="user-infos">
        <p>connecté en tant que {{ `${_pvmoUser?.login}: ${_pvmoUser?.firstName} ${_pvmoUser?.lastName}` }}</p>
      </div>
    } @else if (userDisconnected) {
      <p>utilisateur déconnecté</p>
    } @else if (pvmoUser() === null) {
      <p>utilisateur non présent dans pvmo</p>
    } @else {
      <ml-loader />
    }
  }
}
